'use client';
import { useAuthContext } from '@/context';
import { useAlertContext } from '@/context/alert';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';

const MarkAsSoldModal = (props) => {
	const { setMarkAsSoldModal, markAsSoldModal, listing } = props;

	const { SET_ALERT } = useAlertContext();
	const { LOAD_USER } = useAuthContext();

	const [whereAt, setWhereAt] = useState();
	const [other, setOther] = useState();
	const [data, setData] = useState();

	useEffect(() => {
		if (whereAt === 'Other') {
			setData(other);
		} else {
			setData(whereAt);
		}
	}, [other, whereAt]);

	const markAsSoldHandler = async (event) => {
		event.preventDefault();

		await axios
			.post(
				`${process.env.NEXT_PUBLIC_SERVER_API}/api/listings/${listing._id}/mark-sold`,
				{
					data,
				}
			)
			.then((res) => {
				SET_ALERT({
					msg: 'Listing marked as sold',
					type: 'success',
				});

				LOAD_USER();
			})

			.catch((error) => {
				SET_ALERT({
					msg: 'Server Error',
					type: 'danger',
				});
			});

		setMarkAsSoldModal(!MarkAsSoldModal);
	};

	return (
		<Modal
			show={markAsSoldModal}
			onHide={() => setMarkAsSoldModal(!MarkAsSoldModal)}
		>
			<Modal.Body>
				<p>Where did you sell this item?</p>
				<Form.Group>
					<Form.Select
						name="whereAt"
						onChange={(e) => setWhereAt(e.target.value)}
						required
					>
						<option key={'empty'} value={''}>
							--
						</option>
						<option value="Facebook">Facebook Marketplace</option>
						<option value="OfferUp">Offerup</option>
						<option value="NextDoor">NextDoor</option>
						<option value="Craigslist">Craigslist</option>
						<option value="Other">Other</option>
					</Form.Select>
				</Form.Group>

				{whereAt === 'Other' && (
					<Form.Group className="mb-3" style={{ marginTop: '1em' }}>
						<Form.Label>Specify where:</Form.Label>
						<Form.Control
							placeholder="Where did you sell this item?"
							onChange={(e) => setOther(e.target.value)}
						/>
					</Form.Group>
				)}
			</Modal.Body>

			<Modal.Footer>
				<Button variant="success" onClick={markAsSoldHandler}>
					Mark as sold
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default MarkAsSoldModal;
